// extracted by mini-css-extract-plugin
export var active = "_c8-c";
export var compactArrow = "_c8-5";
export var container = "_c8-0";
export var dot = "_c8-b";
export var dotContainer = "_c8-a";
export var hoverArrowButton = "_c8-7";
export var hoverArrowContainer = "_c8-6";
export var leftHoverArrowContainer = "_c8-8 _c8-6";
export var rightHoverArrowContainer = "_c8-9 _c8-6";
export var slide = "_c8-4";
export var sliderContainer = "_c8-1";
export var sliderContainerVisibleOverflow = "_c8-2";
export var sliderOverflow = "_c8-3";
export var vignetteBoth = "_c8-f";
export var vignetteLeft = "_c8-e";
export var vignetteRight = "_c8-d";